module.exports = __webpack_public_path__ + "media/images/logo-94bc79b025f07f66d4562959023409b8.png";